module.exports = __webpack_public_path__ + "static/media/403.904195aa.png";